module.exports = __webpack_public_path__ + "static/slogan-n-back-f3942d94240f8b53f495ffde618ee181.svg";